module.exports = __webpack_public_path__ + "static/media/eSewa-Nepal.e1b532c2.png";